export default __webpack_public_path__ + "static/assets/med_pill_round_out_L1_solid_x_01_f_mask.a01b473b.png";